
import React from 'react';
import AppLayout from '@/components/layout/AppLayout';
import VehicleCollectionConfirmation from '@/components/application/VehicleCollectionConfirmation';
import ApplicationStepper from '@/components/application/ApplicationStepper';

const VehicleCollectionConfirmationPage = () => {
  return (
    <AppLayout>
      <div className="container mx-auto px-4 md:px-8 pb-8">
        <ApplicationStepper />
        <h1 className="text-2xl font-bold mb-2 text-jungle text-center md:text-2xl">
          Collection Confirmed
        </h1>
        <p className="text-gray-600 mb-8 text-center">
          Your vehicle collection appointment has been confirmed
        </p>
        <VehicleCollectionConfirmation />
      </div>
    </AppLayout>
  );
};

export default VehicleCollectionConfirmationPage;
